import "vuetify/styles";
import "@socotec.io/socio-vue-components/style.css";
import "@socotec.io/socio-aos-component/style.css";
import { createVuetify } from "vuetify";
import { createVueI18nAdapter } from "vuetify/locale/adapters/vue-i18n";
import { i18n } from "@/setup/i18n-setup";
import { useI18n } from "vue-i18n";
import { socioVuetifyConfig } from "@socotec.io/socio-vue-components";
import merge from "lodash/merge";

export default createVuetify(
  merge({}, socioVuetifyConfig, {
    theme: {
      themes: {
        light: {
          colors: {
            bimaction: "#30374b",
            "header-primary": "#28669a",
            "light-blue": "#00ace8",
            "body-color": "#94979a",
            "border-color-root": "#BCC9D5",
            "expert-blue": "#141F35",
            secondary: "#0082DE",
          },
          variables: {
            "theme-on-secondary": "#FFFFFF",
            "input-padding-top": "12px",
          },
        },
      },
    },
    defaults: {
      VSelect: {
        density: "compact",
        color: "primary",
        clearIcon: "mdi-close",
      },
      VTextField: {
        density: "compact",
        color: "primary",
        clearIcon: "mdi-close",
        variant: "underlined",
      },
      VCheckbox: {
        density: "compact",
        color: "primary",
      },
      VAutocomplete: {
        density: "compact",
        color: "primary",
        clearIcon: "mdi-close",
      },
      VCardTitle: {
        style: "display:flex",
      },
      VLayout: {
        style: "z-index: 0",
      },
      VRadioGroup: {
        color: "primary",
      },
      VTextarea: {
        variant: "underlined",
      },
    },
    VTextField: {
      density: "compact",
      color: "primary",
      clearIcon: "mdi-close",
      variant: "outlined",
      locale: {
        adapter: createVueI18nAdapter({ i18n, useI18n }),
      },
      VCheckbox: {
        density: "compact",
        color: "primary",
      },
      VAutocomplete: {
        density: "compact",
        color: "primary",
        clearIcon: "mdi-close",
      },
      VCardTitle: {
        style: "display:flex",
      },
      VLayout: {
        style: "z-index: 0",
      },
      VRadioGroup: {
        color: "primary",
      },
      VTextarea: {
        variant: "outlined",
      },
    },
    locale: {
      adapter: createVueI18nAdapter({ i18n, useI18n }),
    },
  }),
);
